import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const GoogleButtonWrapper = styled.div`
  flex: 0 0 33.3%;
  text-align: right;
  @media (min-width: ${breakpoints.desktop}) {
    flex: none;
  }
`;

export default GoogleButtonWrapper;



// WEBPACK FOOTER //
// ./src/styled-components/GoogleButtonWrapper.js